import { render } from "./LinkNaveMobi.vue?vue&type=template&id=25e85bac&scoped=true"
import script from "./LinkNaveMobi.vue?vue&type=script&lang=js"
export * from "./LinkNaveMobi.vue?vue&type=script&lang=js"

import "./LinkNaveMobi.vue?vue&type=style&index=0&id=25e85bac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e85bac"]])

export default __exports__